export const TAGS_LABELS = {
  documentType: [
    'tagsLabels.documentType.agreementOrContract',
    'tagsLabels.documentType.invoice',
    'tagsLabels.documentType.certificate',
    'tagsLabels.documentType.insurance',
    'tagsLabels.documentType.form',
    'tagsLabels.documentType.policiesAndProcedures',
    'tagsLabels.documentType.letter',
    'tagsLabels.documentType.subscription',
    'tagsLabels.documentType.statementOrReport',
  ],
  documentWorkflow: {
    employment: [
      'tagsLabels.documentWorkflow.employment.recruitment',
      'tagsLabels.documentWorkflow.employment.agreement',
      'tagsLabels.documentWorkflow.employment.newEmployeeManual',
      'tagsLabels.documentWorkflow.employment.policiesAndProcedures',
      'tagsLabels.documentWorkflow.employment.induction',
      'tagsLabels.documentWorkflow.employment.employeeManagement',
      'tagsLabels.documentWorkflow.employment.probation',
      'tagsLabels.documentWorkflow.employment.performanceManagement',
      'tagsLabels.documentWorkflow.employment.managingUnderperformance',
      'tagsLabels.documentWorkflow.employment.termination',
      'tagsLabels.documentWorkflow.employment.accounting',
      'tagsLabels.documentWorkflow.employment.generalAdministration',
      'tagsLabels.documentWorkflow.employment.idCardsPassportsAndLicenses',
    ],
    supplier: [
      'tagsLabels.documentWorkflow.supplier.proposalOrQuote',
      'tagsLabels.documentWorkflow.supplier.agreement',
      'tagsLabels.documentWorkflow.supplier.invoicing',
      'tagsLabels.documentWorkflow.supplier.receipts',
      'tagsLabels.documentWorkflow.supplier.projectMaterials',
      'tagsLabels.documentWorkflow.supplier.termination',
      'tagsLabels.documentWorkflow.supplier.accounting',
      'tagsLabels.documentWorkflow.supplier.generalAdministration',
    ],
    customer: [
      'tagsLabels.documentWorkflow.customer.proposalOrQuote',
      'tagsLabels.documentWorkflow.customer.agreement',
      'tagsLabels.documentWorkflow.customer.invoicing',
      'tagsLabels.documentWorkflow.customer.receipts',
      'tagsLabels.documentWorkflow.customer.customerProjectMaterials',
      'tagsLabels.documentWorkflow.customer.accounting',
      'tagsLabels.documentWorkflow.customer.termination',
      'tagsLabels.documentWorkflow.customer.generalAdministration',
    ],
    business: [
      'tagsLabels.documentWorkflow.company.registration',
      'tagsLabels.documentWorkflow.company.accounting',
      'tagsLabels.documentWorkflow.company.agreements',
      'tagsLabels.documentWorkflow.company.generalAdministration',
      'tagsLabels.documentWorkflow.company.insuranceAndLicenses',
      'tagsLabels.documentWorkflow.company.assets',
    ],
  },
  categories: [
    'tagsLabels.categories.employment',
    'tagsLabels.categories.business',
    'tagsLabels.categories.customers',
    'tagsLabels.categories.suppliers',
  ],
};
